import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("mi_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_120ea8cb-5333-4724-8de1-555e424a9495/artifacts/9ywgxju4_image.png";

export function formatBRL(value) {
  if (value == null || isNaN(value)) return "—";
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
}

// unit = 30 | 100 | 1000 (grams). Value is R$/100g.
export function formatPerWeight(per100g, unit = 100) {
  if (per100g == null || isNaN(per100g)) return "—";
  const v = (per100g * unit) / 100;
  const label = unit === 1000 ? "kg" : `${unit}g`;
  return `${formatBRL(v)}/${label}`;
}

export function formatPer100g(value) {
  return formatPerWeight(value, 100);
}

export const WEIGHT_UNITS = [
  { value: 30, label: "30g" },
  { value: 100, label: "100g" },
  { value: 1000, label: "1kg" },
];

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return "—";
  }
}
